<div class="img-container">
  <img #image [src]="imageSource" crossorigin>
</div>
